export default __webpack_public_path__ + "cb1b5e7b47347043f17255c4daf34733.svg";